import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { apiGet, apiPut } from '../../lib/api';

/**
 * Pragul numerotării automate a registrului de documente al unei firme
 * ([#239](https://github.com/bplugaru/efx-pcrm/issues/239)).
 *
 * De la `nextNumber` în sus numerotează CRM-ul; sub el se scriu de mână, la încărcare,
 * numerele contractelor aduse din sistemul vechi. Ca seria de facturi, **nu e un câmp al
 * firmei**: stă pe contorul registrului și se scrie pe ruta lui.
 */
const numberingSchema = z.object({
  nextNumber: z.number(),
  /** Cel mai mare număr din registru, oricum ar fi venit. `null` = registru gol. */
  highestNumber: z.number().nullable(),
});

export type DocumentNumbering = z.infer<typeof numberingSchema>;

export const documentNumberingQueryKey = (companyId: string) =>
  ['companies', companyId, 'document-numbering'] as const;

export const documentNumberingQueryOptions = (companyId: string) =>
  queryOptions({
    queryKey: documentNumberingQueryKey(companyId),
    queryFn: (): Promise<DocumentNumbering> =>
      apiGet(
        `/companies/${companyId}/document-numbering`,
        z.object({ numbering: numberingSchema }),
      ).then((body) => body.numbering),
  });

export function saveDocumentNumbering(input: {
  companyId: string;
  nextNumber: number;
}): Promise<DocumentNumbering> {
  return apiPut(
    `/companies/${input.companyId}/document-numbering`,
    { nextNumber: input.nextNumber },
    z.object({ numbering: numberingSchema }),
  ).then((body) => body.numbering);
}
